// extracted by mini-css-extract-plugin
export default {"main":"_35ec40aaf5","tit":"e059b1d984","maintitle":"f37f7ec29c","ylw":"_8a0e3b0c8a","white":"_2b110e5635","mv_title":"_4a720feffb","mv_nc":"_53b61ecccb","mv_in":"fa25142ce0"};